export default {
  isAkulaku: throwError,
  isAkulakuAndroid: throwError,
  isAkulakuIOS: throwError,
  support: throwError,
  run: throwError,
};

function throwError() {
  throw new Error("can not call on server side");
}
